<section id="topbar" class="d-lg-block">
  <div class="container d-flex">
    <div class="contact-info mr-auto">
    </div>
    <div class="cta" style="margin-top: 3px;">
      <ul class="login-info">
        <li>
          <button type="button" id="editProfileButton" class="navbar-text text-dark d-none"></button>
        </li>
        <li>
          <button type="button" id="signOut" class="nav-link text-dark d-none" (click)="logOut()">Sign out</button>
        </li>
      </ul>
    </div>
  </div>
</section>
<!-- ======= Header ======= -->
<header id="header">
  <div class="container d-flex">
    <div class="logo mr-auto">
      <h1 class="text-light">
        <a routerLink="/">
          <img src="assets/img/DART-logo-print-color.jpg" alt="" class="img-fluid" />
          <!--<span style="padding-left: 5px;">Student Art Gallery</span>-->
        </a>
      </h1>
    </div>
    <nav class="nav-menu d-lg-block">
      <ul>
        <li><a routerLinkActive="active" routerLink="/">Home</a></li>
        <li class="drop-down">
          <a href="#">Gallery</a>
          <ul>
            <!-- Iterate over years and generate a link for each year -->
            <li *ngFor="let year of years"><a [routerLink]="['/gallery', year]">{{year}}</a></li>
          </ul>
        </li>
        <li *ngIf="contestOpenForVoting">
          <a routerLinkActive="active" mat-raised-button routerLink="/vote">Vote</a>
        </li>
      </ul>
    </nav><!-- .nav-menu -->
  </div>
</header><!-- End Header -->
